module.exports = __webpack_public_path__ + "img/des_happy_4.c33057ec.jpg";